<template>
  <div class="empty-box" :class="type">{{ text }}</div>
</template>
<script>
export default {
  props: {
    type: {
      type: String,
      default: () => ''
    },
    text: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {}
  },
  methods: {}
}
</script>



// WEBPACK FOOTER //
// src/components/EmptyBox.vue